<template>
  <div id="coachRecruit">
    <div class="recruit__top">
      <div class="top__left">
        <a href="/" class="left__logo"><i /></a>
        <p class="left__title">내가 원하는 시간에 활동하고<br/>높은 수업료를 받아보세요</p>
        <p class="left__subtitle">
          <b>프리미엄 고객</b>과 <b>기업 고객</b>을 만나고 <b>커리어</b>를 <b>확장</b>하는 기회,<br/>
          오직 <b>국내 1위 방문 PT 홈핏</b>에서만
        </p>
        <div class="left__btn pc">
          <p class="btn__coach" @click="openSelectModal">
            지원하기 ➔
          </p>
        </div>
        <i class="left__bottom"></i>
        <p class="left__btn mo" @click="openSelectModal">
          지원하기
        </p>
      </div>
      <div class="top__right">
        <video class="pc" autoplay muted loop playsinline preload="auto">
          <source
            src="https://dcse8twossp9.cloudfront.net/static/img/coach/recruit/240603-전문가지원페이지-PC.mp4"
          />
        </video>
        <video class="mo" autoplay muted loop playsinline preload="auto">
          <source
            src="https://dcse8twossp9.cloudfront.net/static/img/coach/recruit/240603-전문가지원페이지-모바일.mp4"
          />
        </video>
      </div>
    </div>
    <a href="/" class="recruit__logo"><i /></a>
    <div class="recruit__container">
      <p class="recruit__title">홈핏과 함께하면,</p>
      <div class="recruit__swiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <div class="slide__img img__01 lazy"></div>
            <p class="slide__title">원하는 시간과 지역에서 활동할 수 있어요.</p>
          </div>
          <div class="swiper-slide">
            <div class="slide__img img__02 lazy"></div>
            <p class="slide__title">동일 성별 매칭이라 안심이 돼요.</p>
          </div>
          <div class="swiper-slide">
            <div class="slide__img img__03 lazy"></div>
            <p class="slide__title">
              지속적인 신규 회원 매칭으로 만족도가 높아져요.
            </p>
          </div>
          <div class="swiper-slide">
            <div class="slide__img img__04 lazy"></div>
            <p class="slide__title">회원 관리 매뉴얼이 있어서 편해요.</p>
          </div>
          <div class="swiper-slide">
            <div class="slide__img img__05 lazy"></div>
            <p class="slide__title">부가적인 수익을 창출 할 수 있어요.</p>
          </div>
          <div class="swiper-slide">
            <div class="slide__img img__06 lazy"></div>
            <p class="slide__title">
              활동 ON/OFF 설정으로 자유로운 수업이 보장돼요.
            </p>
          </div>
          <div class="swiper-slide">
            <div class="slide__img img__07 lazy"></div>
            <p class="slide__title">
              다양한 기업 출강 경험을 쌓을 수 있어요.
            </p>
          </div>
          <div class="swiper-slide slide__last"></div>
        </div>
      </div>
      <div class="recruit__bar"><span id="bar"></span></div>
    </div>
    <Income
      :lessonInfo="lessonInfo"
      @set-purpose="setPurpose"
      @set-lesson-count="setLessonCount"
    />
    <div class="recruit__container img__container img__01 lazy">
      <p class="img__title">
        전문가매니저를 통해 활동과 관련된<br />역량 강화 교육과 상담을
        받아보세요
      </p>
      <p class="img__btn" @click="openConsultingModal">자세히 알아보기</p>
    </div>
    <div class="recruit__container">
      <div class="recruit__wrapper">
        <p class="recruit__title">많은 전문가가 <br />홈핏을 추천합니다</p>
        <div class="recruit__content">
          <div
            class="content__big"
            @click="
              moveToInterview('https://homefit.co.kr/board/view/14321710')
            "
          >
            <p class="content__title">
              회원님들을 만날 때마다<br />매 순간 보람을 느끼고 있어요
            </p>
            <p class="content__sign">
              <img
                src="https://dcse8twossp9.cloudfront.net/static/img/recruit/miss-u@3x.png"
                alt="miss-u"
                class="sign__top"
              />
              <span class="sign__bottom">최우수 전문가</span>
            </p>
            <i class="content__plus" />
          </div>
          <div>
            <div
              class="content__small small__01"
              @click="
                moveToInterview('https://homefit.co.kr/board/view/14321725')
              "
            >
              <p class="content__title">
                매일 아침 눈을 뜰 때<br />가슴이 벅차고 설레입니다
              </p>
              <i class="content__plus" />
            </div>
            <div
              class="content__small small__02"
              @click="
                moveToInterview('https://homefit.co.kr/board/view/14321730')
              "
            >
              <p class="content__title">
                제 수업을 통해 변화하는<br />회원님들을 보여, 전문가로서의<br />자긍심을
                느껴요
              </p>
              <i class="content__plus" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <Condition />
    <div class="recruit__container">
      <div class="recruit__wrapper">
        <p class="recruit__title">홈핏 전문가 선발은 <br />이렇게 진행되어요</p>
        <div class="recruit__selection">
          <div class="selection__column">
            <div class="selection__row row__red">
              <img
                class="lazy"
                data-src="https://dcse8twossp9.cloudfront.net/static/img/icon/rec-01.svg"
                alt="rec"
              />
              <p class="selection__title">지원서 심사</p>
              <p class="selection__step">step1</p>
            </div>
            <div class="selection__row row__blue">
              <img
                class="lazy"
                data-src="https://dcse8twossp9.cloudfront.net/static/img/icon/rec-02.svg"
                alt="rec"
              />
              <p class="selection__title">사전 미팅 및 메뉴얼 교육</p>
              <p class="selection__step">step2</p>
            </div>
          </div>
          <div class="selection__column">
            <div class="selection__row row__yellow">
              <img
                class="lazy"
                data-src="https://dcse8twossp9.cloudfront.net/static/img/icon/rec-03.svg"
                alt="rec"
              />
              <p class="selection__title">정보 등록 및 서류 제출</p>
              <p class="selection__step">step3</p>
            </div>
            <div class="selection__row row__green">
              <img
                class="lazy"
                data-src="https://dcse8twossp9.cloudfront.net/static/img/icon/rec-04.svg"
                alt="rec"
              />
              <p class="selection__title">홈핏 전문가 등록 완료</p>
              <p class="selection__step">step4</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Faq @open-faq-modal="openFaqModal" />
    <div class="recruit__container img__container img__02 bmnone lazy">
      <p class="img__title">
        홈핏의 확실한 회원 유치와<br />폭넓은 혜택을 보장받으세요
      </p>
    </div>
    <Footer />
    <div class="recruit__footer" :class="{ on: isFooter }">
      <p class="footer__left" @click="openSelectModal">지원하기</p>
    </div>
    <FaqModal v-if="isFaqModal" @close-faq-modal="closeFaqModal" />
    <ConsultingModal
      v-if="isConsultingModal"
      @close-consulting-modal="closeConsultingModal"
    />
    <CommonTripleChooseModal
      v-if="isSelectModal"
      theme="black"
      title="어떤 전문가로 지원하시겠어요?"
      content="* 운동 : 요가, 필라테스, 웨이트 수업 가능자<br>* 요가명상 : 요가와 명상 (바디스캔, 싱잉볼, 아로마 등) 수업 가능자<br>* 전문 통증케어 : 물리치료사 면허증, 운동사 자격증, 스포츠의학 전공자 등 전문 통증케어 수업 가능자<br><br>* 운동&요가명상 모두 수업 가능한 경우, 요가명상 전문가로 지원하세요.<br>* 운동&전문 통증케어 모두 수업 가능한 경우, 전문 통증케어로 지원하세요."
      :items="[
        { name: '운동', value: 'workout' },
        { name: '요가명상', value: 'meditation' },
        { name: '전문 통증케어', value: 'care' },
      ]"
      @click-item="clickSelectItem"
      @close-modal="closeSelectModal"
      @open-alert="openEmojiAlert"
    />
    <LoadingModal v-if="isLoading" />
    <CommonEmojiAlert
      v-if="isMusicEmojiAlert"
      :config="{
        title: '음악 전문가 접수 일시중단',
        content:
          '현재 음악 전문가 지원자 수 증가에 따라<br>지원서 접수를 잠시 중단 중입니다.<br><br>향후 모집 공고 게시 후<br>다시 지원해주시기 바랍니다.<br>(음악 관련 채널 등 공고 게시 예정)<br><br>감사합니다.'
      }"
      @close-alert="closeEmojiAlert"
    />
    <CommonEmojiAlert
      v-if="isArtEmojiAlert"
      :config="{
        title: '미술 전문가 접수 일시중단',
        content:
          '현재 미술 전문가 지원자 수 증가에 따라<br>지원서 접수를 잠시 중단 중입니다.<br><br>향후 모집 공고 게시 후<br>다시 지원해주시기 바랍니다.<br>(미술 관련 채널 등 공고 게시 예정)<br><br>감사합니다.'
      }"
      @close-alert="closeArtEmojiAlert"
    />
    <PainCareInfoModal
      v-if="isPainCareInfoModal"
      @close-pain-care-info-modal="isPainCareInfoModal = false"
      @click-ok="movePage('/form/apply_form/?type=care')"
      @click-no="returnToSelectModal"
    />
  </div>
</template>
<script>
const PRICE = {
  A: { price: 44000 },
  B: { price: 50000 },
  C: { price: 57000 },
  D: { price: 48000 },
  E: { price: 42000 },
  F: { price: 42000 },
  G: { price: 47000 },
  H: { price: 51000 },
}
const PRICE_MONTH = 25

const $ = window.$
import Swiper from 'swiper/bundle'
import 'swiper/swiper-bundle.min.css'
import Condition from '@/components/recruit/Condition'
import Faq from '@/components/recruit/Faq'
import Income from '@/components/recruit/Income'
import Footer from '@/components/common/CommonFooterV3'
export default {
  name: 'CoachRecruit',
  components: {
    Condition,
    Faq,
    Income,
    Footer,
    FaqModal: () => import('@/components/recruit/FaqModal'),
    ConsultingModal: () => import('@/components/recruit/ConsultingModal'),
    CommonTripleChooseModal: () =>
      import('@/components/common/CommonTripleChooseModal'),
    CommonEmojiAlert: () => import('@/components/common/CommonEmojiAlert'),
    LoadingModal: () => import('@/components/common/LoadingModal'),
    PainCareInfoModal: () =>
      import('@/components/recruit/coachApplyForm/PainCareInfoModal'),
  },
  data() {
    return {
      price: PRICE,
      priceMonth: PRICE_MONTH,
      isMobile: window.homefit.isMobile,
      isPainCareInfoModal: false,
      isFaqModal: false,
      isConsultingModal: false,
      isSelectModal: false,
      isFooter: false,
      isMusicEmojiAlert: false,
      isArtEmojiAlert: false,
      isLoading: false,
      lessonInfo: {
        purpose: 'A',
        count: 3,
        price: 0
      },
      swiper: null
    }
  },
  mounted() {
    $('.hf_layout_header_uikit_wrap').hide()
    $('.uk-sticky-placeholder').hide()
    let vh = window.innerHeight * 0.01
    document.documentElement.style.setProperty('--vh', `${vh}px`)
    this.initializeSwiper()
    this.setLessonPrice()
    this.initNumberAnimation(this.lessonInfo.price, 'int')

    window.addEventListener('scroll', e => {
      const scroll = e.pageYOffset
      this.isFooter = scroll > 80
    })
  },
  watch: {
    lessonInfo: {
      deep: true,
      handler() {
        this.setLessonPrice()
        this.initNumberAnimation(this.lessonInfo.price, 'int')
      }
    }
  },
  methods: {
    movePage(url) {
      location.href = url
    },
    initializeSwiper() {
      this.swiper = new Swiper('.recruit__swiper', {
        centeredSlides: false,
        slidesPerView: 'auto',
        spaceBetween: 12,
        observer: true,
        setWrapperSize: true,
        touchMoveStopPropagation: true,
        breakpoints: {
          769: {
            spaceBetween: 20
          }
        },
        on: {
          activeIndexChange: e => {
            const max = this.isMobile ? 100 / 5 : 100 / 3
            const dif = this.isMobile ? 66 / 5 : 66 / 3

            const position = e.activeIndex * max
            const minus = e.activeIndex * dif

            document.querySelector('#bar').style.left =
              e.activeIndex === 0 ? '0' : `calc(${position}% - ${minus}px)`

            console.log(e.activeIndex)
          }
        }
      })
    },
    initNumberAnimation(value, type) {
      $({ val: 0 }).animate(
        { val: value },
        {
          duration: 1000,
          step: function() {
            let num =
              type === 'int'
                ? Math.floor(this.val).toLocaleString()
                : this.val.toFixed(1).toLocaleString()
            $('#totalPrice').text(num)
          },
          complete: function() {
            let num =
              type === 'int'
                ? Math.floor(this.val).toLocaleString()
                : this.val.toFixed(1).toLocaleString()
            $('#totalPrice').text(num)
          }
        }
      )
    },
    openFaqModal() {
      this.isFaqModal = true
    },
    closeFaqModal() {
      this.isFaqModal = false
    },
    openConsultingModal() {
      this.isConsultingModal = true
    },
    closeConsultingModal() {
      this.isConsultingModal = false
    },
    openSelectModal() {
      this.isSelectModal = true
    },
    closeSelectModal() {
      this.isSelectModal = false
    },
    returnToSelectModal() {
      this.isPainCareInfoModal = false
      this.isSelectModal = true
    },
    setPurpose(val) {
      this.lessonInfo.purpose = val
    },
    setLessonCount(val) {
      this.lessonInfo.count = val
    },
    moveToInterview(url) {
      window.open(url, '_blank')
    },
    lockBodyScroll() {
      const html = document.querySelector('html')
      html.style.overflow = 'hidden'
    },
    unLockBodyScroll() {
      const html = document.querySelector('html')
      html.style.removeProperty('overflow')
    },
    setLessonPrice() {
      this.lessonInfo.price = this.lessonInfo.price =
        this.price[this.lessonInfo.purpose].price *
        this.priceMonth *
        this.lessonInfo.count
    },
    clickSelectItem(val) {
      if (val === 'workout') location.href = '/form/apply_form/?type=workout'
      else if (val === 'meditation')
        location.href = '/form/apply_form_for_meditation/?type=meditation'
      else if (val === 'care'){
          this.isSelectModal = false
          this.isPainCareInfoModal =true
      }
    },
    openEmojiAlert(val) {
      if (val === 'music') this.isMusicEmojiAlert = true
      else if (val === 'art') this.isArtEmojiAlert = true
    },
    closeEmojiAlert() {
      this.isMusicEmojiAlert = false
    },
    closeArtEmojiAlert() {
      this.isArtEmojiAlert = false
    },
    toggleLoadingModal(val) {
      this.isLoadingModal = val
    }
  }
}
</script>
<style lang="scss">
@import '@/assets/scss/coaches/coach_recruit.scss';
</style>
